// extracted by mini-css-extract-plugin
module.exports = {"root":"HeroGrid_root__pI_7p"};